/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */

document.addEventListener("DOMContentLoaded", function () {

  let spImgList = [
    "https://cdn.shopify.com/s/files/1/0702/8074/1151/files/20260108-p1.png",
    "https://cdn.shopify.com/s/files/1/0702/8074/1151/files/20260108-p2.png",
    "https://cdn.shopify.com/s/files/1/0702/8074/1151/files/20260108-p3.png",

    "https://cdn.shopify.com/s/files/1/0702/8074/1151/files/20260108-b1.png",
    "https://cdn.shopify.com/s/files/1/0702/8074/1151/files/20260108-b2.png",
    "https://cdn.shopify.com/s/files/1/0702/8074/1151/files/20260108-b3.png",
    "https://cdn.shopify.com/s/files/1/0702/8074/1151/files/20260108-b4.png",
    "https://cdn.shopify.com/s/files/1/0702/8074/1151/files/20260108-b5.png",
    "https://cdn.shopify.com/s/files/1/0702/8074/1151/files/20260108-b6.png",
    "https://cdn.shopify.com/s/files/1/0702/8074/1151/files/20260108-c1.png",
    "https://cdn.shopify.com/s/files/1/0702/8074/1151/files/20260108-c2.png",
    "https://cdn.shopify.com/s/files/1/0702/8074/1151/files/20260108-c3.png",
    "https://cdn.shopify.com/s/files/1/0702/8074/1151/files/20260108-c4.png",
    "https://cdn.shopify.com/s/files/1/0702/8074/1151/files/20260108-c5.png",
    "https://cdn.shopify.com/s/files/1/0702/8074/1151/files/20260108-c6.png",
    "https://cdn.shopify.com/s/files/1/0702/8074/1151/files/20260108-c7.png",
    "https://cdn.shopify.com/s/files/1/0702/8074/1151/files/20260108-c8.png",
  ];
  
  // PC端和移动端价格
  let prods = window.product
  let sp_price1_pc = prods[0].price / 100;
  let sp_price2_pc = prods[0].compare_at_price / 100;
  let sp_price1_m = prods[0].price / 100;
  let sp_price2_m = prods[0].compare_at_price / 100;

  function calcTotal(price, num) {
    let result = Number(price) * Number(num);
    return result.toFixed(2);
  }
  
  function isMobile() {
    return document.body.clientWidth <= 1080;
  }
  
  // PC端产品卡片点击切换放大
  $(".sp-combo-cards .sp-combo-card").click(function (e) {
    // 只在PC端生效
    if (isMobile()) return;
    
    // 阻止事件冒泡，避免点击内部元素时触发
    if ($(e.target).closest('.sp-combo-btn, .sp-reduce, .sp-add, input').length) return;
    
    if (!$(this).hasClass("active")) {
      $(".sp-combo-cards .sp-combo-card").removeClass("active");
      $(this).addClass("active");
    }
  });
  
  $(".sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
    if (isMobile()) {
      $("#sp_price1_m").html(calcTotal(sp_price1_m, input.value));
      $("#sp_price2_m").html(calcTotal(sp_price2_m, input.value));
    } else {
      $("#sp_price1").html(calcTotal(sp_price1_pc, input.value));
      $("#sp_price2").html(calcTotal(sp_price2_pc, input.value));
    }
  });
  $(".sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    if (isMobile()) {
      $("#sp_price1_m").html(calcTotal(sp_price1_m, input.value));
      $("#sp_price2_m").html(calcTotal(sp_price2_m, input.value));
    } else {
      $("#sp_price1").html(calcTotal(sp_price1_pc, input.value));
      $("#sp_price2").html(calcTotal(sp_price2_pc, input.value));
    }
  });


  $(".sp-option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");

    let colorOptions = $(".sp-opt-group1 .sp-option.active").index();
    let numOptions = $(".sp-opt-group2 .sp-option.active").index();
    let _index = numOptions;
    // $("#sptext1").text(sptextList[colorOptions]);
    // let _index = colorOptions;
    _swiper.slideToLoop(_index);
  });

  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  // 第一板块轮播图
  var part1Swiper = new Swiper(".sp-part1-swiper", {
    effect: "fade",
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    loop: true,
    speed: 1000,
    on: {
      slideChange: function () {
        var index = this.realIndex;
        $(".sp-part1-pagination .sp-dot").removeClass("active");
        $(".sp-part1-pagination .sp-dot").eq(index).addClass("active");
      }
    }
  });

  // 点击指示器切换
  $(".sp-part1-pagination .sp-dot").click(function () {
    var index = $(this).index();
    part1Swiper.slideToLoop(index);
  });

  // 移动端第一板块轮播图
  var part1SwiperM = new Swiper(".sp-part1-swiper-m", {
    effect: "fade",
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    loop: true,
    speed: 1000,
    on: {
      slideChange: function () {
        var index = this.realIndex;
        $(".sp-part1-pagination-m .sp-dot").removeClass("active");
        $(".sp-part1-pagination-m .sp-dot").eq(index).addClass("active");
      }
    }
  });

  // 移动端点击指示器切换
  $(".sp-part1-pagination-m .sp-dot").click(function () {
    var index = $(this).index();
    part1SwiperM.slideToLoop(index);
  });

  // 移动端媒体图标走马灯
  new Swiper(".sp-media-marquee", {
    spaceBetween: 109,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    loop: true,
    speed: 5000,
    slidesPerView: "auto",
    allowTouchMove: false,
  });

  // 移动端第四板块轮播图
  var part4SwiperM = new Swiper(".sp-part4-swiper-m", {
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    loop: true,
    speed: 800,
    on: {
      slideChange: function () {
        var index = this.realIndex;
        $(".sp-part4-pagination-m .sp-dot").removeClass("active");
        $(".sp-part4-pagination-m .sp-dot").eq(index).addClass("active");
      }
    }
  });

  // 移动端第四板块点击指示器切换
  $(".sp-part4-pagination-m .sp-dot").click(function () {
    var index = $(this).index();
    part4SwiperM.slideToLoop(index);
  });

  // 移动端第五板块轮播图
  var part5SwiperM = new Swiper(".sp-part5-swiper-m", {
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    loop: true,
    speed: 1000,
  });

  // 移动端第五板块轮播切换按钮
  $(".sp_mobile .sp-part5-m .sp-prev").click(function () {
    part5SwiperM.slidePrev();
  });
  $(".sp_mobile .sp-part5-m .sp-next").click(function () {
    part5SwiperM.slideNext();
  });

  // 第五板块轮播图
  var part5Swiper = new Swiper(".sp-part5-swiper", {
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    loop: true,
    speed: 800,
  });

  // 第五板块轮播切换按钮
  $(".sp-big-bg .sp-part5 .sp-prev").click(function () {
    part5Swiper.slidePrev();
  });
  $(".sp-big-bg .sp-part5 .sp-next").click(function () {
    part5Swiper.slideNext();
  });

  new Swiper(".sp-swiper-fade-top", {
    spaceBetween: 10,
    effect: "fade",
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 2000,
    },
    speed: 2000,
  });

  // // 按钮轮播
  new Swiper(".sp-btn-loop", {
    spaceBetween: 10,
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      reverseDirection: true,
    },
    loop: true,
  });

  new Swiper(".sp-swiper1", {
    spaceBetween: 60,
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 0,
    },
    loop: true,
    speed: 6000,
    slidesPerView: "auto",
  });
  new Swiper(".sp-swiper1-m", {
    spaceBetween: 30,
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 0,
    },
    loop: true,
    speed: 6000,
    slidesPerView: "auto",
  });

  new Swiper(".sp-swiper2", {
    spaceBetween: 16,
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 0,
    },
    loop: true,
    speed: 6000,
    slidesPerView: "auto",
  });

  jQuery(".sp-scroll2").slide({
    mainCell: ".nav-imgs",
    autoPlay: true,
    effect: "leftMarquee",
    interTime: 12,
    vis: 1,
    scroll: 1,
  });

  let _swiper = new Swiper(".sp-swiper-pro", {
    speed: 1,
    spaceBetween: 0,
  });

  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");
      if (document.body.clientWidth <= 1080) {
        let scale = document.body.clientWidth / 1080;
        $("#root").css("zoom", scale);
      } else {
        const scale = document.body.clientWidth / 1920;
        $("#root").css("zoom", scale);
      }

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              $("#root").css("zoom", "normal");
              if (document.body.clientWidth <= 1080) {
                let scale = document.body.clientWidth / 1080;
                $("#root").css("zoom", scale);
              } else {
                const scale = document.body.clientWidth / 1920;
                $("#root").css("zoom", scale);
              }
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
      config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();

    preloadImages(spImgList);

    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop =
          document.body.clientWidth <= 1080
            ? targetElement.offsetTop - $(".sp-nav").height()
            : targetElement.offsetTop;
        let sptop = document.body.clientWidth <= 1080 ? 60 : 90;

        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            sptop * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        });
      });
    });

    // IOS字体多了间距的处理，给节点添加sp_system类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log("Android");
    } else if (isIOS) {
      console.log("iOS");
    } else if (isPC) {
      console.log("PC");
    } else {
      $(".sp_system").css("letter-spacing", "-4px");
    }
  }

  mainRender();

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span");
    const paragraph = gradually.querySelector(".sp-sub-title");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个span和i动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }

  // // 点击按钮
  // $(".sp-video-btn").click(function () {
  //   $(".sp-mask").css("display", "flex");
  // });

  // 菜单
  $(".sp-menu-btn").click(function (e) {
    $(".sp-menu-mask").show();
  });

  $(".sp-menu-mask").click(function (e) {
    // if ($(e.target).closest(".sp-menu-mask li").length > 0) {
    // } else {
    $(".sp-menu-mask").hide();
    // }
  });

  // 滚动隐藏顶部
  if (
    $(window).scrollTop() >
    $(".sp_header").height() * $("div#root").css("zoom")
  ) {
    $(".sp_header-wrap").addClass("sp-fixed");
  } else {
    $(".sp_header-wrap").removeClass("sp-fixed");
  }

  // 移动端底部固定按钮显示/隐藏
  let headerHeight = $(".sp_header").height() * $("div#root").css("zoom");

  $(window).scroll(function () {
    if (
      $(window).scrollTop() >
      $(".sp_header").height() * $("div#root").css("zoom")
    ) {
      $(".sp_header-wrap").addClass("sp-fixed");
    } else {
      $(".sp_header-wrap").removeClass("sp-fixed");
    }

    // 移动端底部固定按钮：滑过首屏显示，回到首屏隐藏
    if (document.body.clientWidth <= 1080) {
      if ($(window).scrollTop() > headerHeight) {
        $(".sp-fix-bottom").addClass("show");
      } else {
        $(".sp-fix-bottom").removeClass("show");
      }
    }
  });

//   $(document).on("click", ".sp_buy_now", function () {
//     let num = $(this).siblings('.addGroup').find('input').val()
//     console.log("num",num)
//     num == undefined ? num = 1 : ''
//     let id = $(this).attr('data-id')
//     window.location.href = '/cart/' + id + ':' + num
//   });
 $(document).on("click", ".sp_buy_now", function () {
    // 方法1：使用closest找到最近的卡片，再找input
    let num = $(this).closest('.sp-combo-card').find('.addGroup input').val();
    
    // 如果还是undefined，尝试其他方法
    if (num === undefined) {
        // 方法2：尝试通过卡片索引找到对应的input
        let cardIndex = $(this).closest('.sp-combo-card').data('index');
        num = $('.sp-combo-card[data-index="' + cardIndex + '"] .addGroup input').val();
    }
    
    // 默认值处理
    num = num === undefined ? 1 : num;
    
    // 确保num是数字
    num = parseInt(num) || 1;
    
    console.log("num", num);
    let id = $(this).attr('data-id');
    window.location.href = '/cart/' + id + ':' + num;
});

  let initNum = 0;
  $(document).on("click", ".sp_add_cart", function () {
    // 购物车加购动画
    $(this).children("img").addClass("on");
    $(".sp-cart .num").show();
    setTimeout(function () {
      $(" .cart-btn").children("img").removeClass("on");
    }, 500);
    $(" .sp-cart").addClass("on");
    setTimeout(function () {
      $(".sp-cart").removeClass("on");
    }, 500);

    let spNum = $("#calcNumber")[0].value;
    initNum += Number(spNum);

    // $("#calcNumber").val(1);

    $(".cardNum").each(function () {
      $(this).html(initNum);
    });
    $(".cardNum").removeClass("sp-gray");
    // handleAddToCart(initNum);

    var imgs = $(".sp_product_part .swiper-slide-active").find("img");
    // var imgs = $(".sp_product_part .sp-img-p.active");

    imgs.each(function () {
      var $img = $(this);
      var flyer = $img[0].cloneNode(true);
      flyer.classList.add("sp_clone");

      $(".sp_product_part").append(flyer);
      $(flyer).css({
        width: $img[0].width,
        height: $img[0].height,
        background: "#e7e9ef",
        position: "fixed",

        top: $img[0].offsetTop,
        left: $img.offset().left,
        "z-index": 99,
      });
      let finish;
      if (document.body.clientWidth <= 1080) {
        finish = $(".sp-btn-style2 .sp-cart");

        $(flyer).animate(
          {
            top: $(".sp-btn-style2")[0].offsetTop,
            left:
              $(".sp-btn-style2  .sp-area2")[0].offsetLeft + finish.width() / 2,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          "linear",
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach();
              }
            );
          }
        );
      } else {
        finish = $(".sp_pc .sp-cart");
        $(flyer).animate(
          {
            top: finish[0].offsetTop,
            left: finish[0].offsetLeft + finish.width() / 2,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          "linear",
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach();
              }
            );
          }
        );
      }
    });
  });

  // 问答
  $(".sp-qa2-question").on("click", function () {
    var $currentItem = $(this).closest(".sp-qa2-item");
    var $answer = $currentItem.find(".sp-qa2-answer");

    // 如果当前项已经打开 -> 关闭它
    if ($currentItem.hasClass("active")) {
      $answer.slideUp(300);
      $currentItem.removeClass("active");
    }
    // 如果当前项是关闭的 -> 开启它 (并关闭其他项)
    else {
      // 关闭其他所有项
      $(".sp-qa2-item").removeClass("active");
      $(".sp-qa2-answer").slideUp(300);

      // 开启当前项
      $currentItem.addClass("active");
      $answer.slideDown(300);
    }
  });

  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName("sp-fade-box");
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll(".sp-ani");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`;
              span.style.animationDelay = `${index * 0.5 + 0.5}s`;
            });

            observerAni.unobserve(gradually2);
          }
        });
      },
      {
        threshold: 0.1,
      }
    );
    observerAni.observe(gradually2);
  }
  // 文本渐出动画
  const graduallyList3 = document.getElementsByClassName("sp-fade-box2");
  for (let gradually3 of graduallyList3) {
    const paragraph3 = gradually3.querySelectorAll(".sp-ani2");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph3.forEach((span, index) => {
              span.style.animation = `sp-fade-left 1s ease forwards`;
              span.style.animationDelay = `${index * 0.3 + 1}s`;
            });

            observerAni.unobserve(gradually3);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observerAni.observe(gradually3);
  }
});
